import { goBack } from "assets/icons";
import styled from "@emotion/styled";
import { Card, Col, Form, Row, Typography} from "antd";
import { useNavigate } from "react-router-dom";
import SettingMyQrCodeForm from "./SettingMyQrCodeForm";
import { useAppSelector } from "store";
import { useEffect, useState } from "react";

const SettingMyQrCode = () => {

  const { contact } = useAppSelector((state) => state.auth);
  const navigate = useNavigate();
  console.log(contact)

  return (
    <>
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <HeaderTabs>
              <IconWrapper
                onClick={() => {
                  navigate("/profiles/profile-setting");
                }}
              >
                <SpanIcon>{goBack}</SpanIcon>
              </IconWrapper>
              <Typography.Title  level={5} >คิวอาร์โค้ดของฉัน</Typography.Title>
              <RightIconWrapper></RightIconWrapper>
            </HeaderTabs>
            <WrapperAll>
              <SettingMyQrCodeForm id={contact?.id || 'test'}></SettingMyQrCodeForm>
              {/* <SettingMyProfileForm
                form={form}
                onFinish={onFinish}
                avatar={avatar}
              /> */}
            </WrapperAll>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default SettingMyQrCode;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
`;
